import React, { Fragment } from "react";
import { useSelector } from "react-redux";
import Button from "../../../../common/Button";
import Title from "../../../learning/presentational/header/Title";

const Header = ( props ) => {

  const answeringQuestions = useSelector( state => state.answeringQuestions );

  const { Closer } = props;

  return (
    <div className="header dark">
      <div className="inner">
        <div className="headerBox">
          <div className="headerBox_head">
            <Title>{ answeringQuestions.data.stgNm }</Title>
            <Closer><Button className="btn-close-wrap">닫기</Button></Closer>
          </div>
          <div className="headerBox_body">
            <div className="header-qa-wrap">
              <div className="qa-cnt-wrap"><span>{ answeringQuestions.answeringCount }</span> /{ answeringQuestions.listData.length }</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );

};

Header.defaultProps = {
  Closer : Fragment,
  QuestionListController : Fragment,
  AnswerListController : Fragment
};

export default Header;
